<template>
  <ion-page>
    <master-layout pageTitle="مأموریتهای توزیع">
      <IonCardContent>
        <DataTable :card="true" auto-reload="1" v-if="route" :headers="headers" :route="route"></DataTable>
      </IonCardContent>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
 IonPage,IonCardContent
} from "@ionic/vue";


export default {
  data()
  {
    return {
      headers: [
        'شماره',
        'تاریخ شروع',
        'تاریخ پایان',
        'نوع',
        'وضعیت',
        'امکانات',
      ],
      route:null,
    };
  },
  async created()
  {
    this.route = 'deliverMission/listAjax';
  },
  components: {
    DataTable, IonPage,IonCardContent
  },
};
</script>

<style scoped>

</style>